export const height100PCT = () => ({
  height: "100%",
  margin: "0 auto",
  width: "100%",
});
